/**
 * @file check-round.icon.tsx
 * @description Компонент с иконкой активного тега.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

export const CheckRound = () => {
    return (
        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.97916 4.3125L6.51041 0.78125C6.59374 0.697917 6.69097 0.65625 6.80208 0.65625C6.91319 0.65625 7.01041 0.697917 7.09374 0.78125C7.17708 0.864583 7.21874 0.963611 7.21874 1.07833C7.21874 1.19306 7.17708 1.29194 7.09374 1.375L3.27083 5.20833C3.18749 5.29167 3.09027 5.33333 2.97916 5.33333C2.86805 5.33333 2.77083 5.29167 2.68749 5.20833L0.895827 3.41667C0.812494 3.33333 0.772494 3.23444 0.775827 3.12C0.77916 3.00556 0.822633 2.90653 0.906244 2.82292C0.989855 2.73931 1.08888 2.69764 1.20333 2.69792C1.31777 2.69819 1.41666 2.73986 1.49999 2.82292L2.97916 4.3125Z"
                fill="black"
            />
        </svg>
    );
};
